import Selector, { SelectorProps } from 'components/Mobile/Selector'
import { useRootLoaderData } from 'components/Root.loader'
import { DocTypeOption } from 'components/UploadDialog/types'
import { DOC_TYPE } from 'config'
import useOcrBuilders from 'hooks/useOcrBuilders'
import { OcrBuilder } from 'types'

const TEMPLATE_PREFIX = '_ocrtmp#'

function pickOptions(options: DocTypeOption[], ocrBuilders: OcrBuilder[], useConcur: boolean) {
  const useableDocTypeOptions = options
    .filter((type) => !type.disabled)
    .map(({ label, value }) => ({ label, value }))

  const templateOptions = ocrBuilders.map((x) => ({
    label: x.documentTypeName,
    value: `${TEMPLATE_PREFIX}${x.ocrBuilderConfigID}`,
  }))

  // concur userには非表示
  return useableDocTypeOptions.concat(
    templateOptions,
    !useConcur
      ? [
          {
            label: 'テキスト・表',
            value: DOC_TYPE.GENERAL_OCR,
          },
        ]
      : [],
  )
}

function parseOption(rawValue: string) {
  const isTemplate = rawValue.startsWith(TEMPLATE_PREFIX)
  const value = isTemplate ? rawValue.slice(TEMPLATE_PREFIX.length, rawValue.length) : rawValue

  return { isTemplate, value }
}

type Props = {
  docType: string | null
  ocrBuilderConfigID: number | null
  onOcrBuilderConfigIDChange: (value: number | null) => void
  onDocTypeChange: (value: string) => void
  docTypeOptions: DocTypeOption[]
}

const DocTypeSelector = (props: Props) => {
  const {
    docType,
    ocrBuilderConfigID,
    docTypeOptions,
    onDocTypeChange,
    onOcrBuilderConfigIDChange,
  } = props
  const { normalOcrBuilders, verifyOcrBuilders } = useOcrBuilders()
  // 現状normalのみ
  // eslint-disable-next-line no-constant-condition
  const ocrBuilders = true ? normalOcrBuilders : verifyOcrBuilders
  const userGroupConfig = useRootLoaderData().userGroupConfig

  const useableDocTypeOptions = pickOptions(
    docTypeOptions,
    userGroupConfig.useOCRBuilder ? ocrBuilders : [],
    userGroupConfig.useConcur,
  )

  const handleChange: SelectorProps['onChange'] = (payload) => {
    const { value, isTemplate } = parseOption(payload)
    if (isTemplate) {
      onDocTypeChange(DOC_TYPE.OCR_BUILDER)
      onOcrBuilderConfigIDChange(parseInt(value))
    } else {
      onDocTypeChange(value)
      // onOcrBuilderConfigIDChange(null) // <-- done inside doctype change handler
    }
  }

  const value =
    docType === DOC_TYPE.OCR_BUILDER ? `${TEMPLATE_PREFIX}${ocrBuilderConfigID}` : docType

  return (
    <Selector
      label="文書タイプ"
      description="OCRする文書タイプを選択"
      value={value}
      options={useableDocTypeOptions}
      onChange={handleChange}
    />
  )
}

export default DocTypeSelector
